/* ============================================================
   FRAISE NOIRE — SÉLECTEUR DE COLORIS (fiche produit)
   Affiche les autres déclinaisons de la même ligne sous forme de
   pastilles cliquables : « ils l'ont en quelle couleur ? » est la
   première question d'un acheteur, elle a désormais sa réponse.
   Données : js/familles-data.js (window.FN_FAMILLES).
   ============================================================ */
(() => {
  'use strict';
  const FAM = window.FN_FAMILLES || {};
  const P = window.FN_PRODUCTS || [];
  if (!Object.keys(FAM).length || !P.length) return;

  /* 20/10/2026 — on lisait le handle dans `?handle=`, un paramètre que l'URL
     d'une fiche ne porte pas : `location.search` valait "" et le script
     sortait à sa deuxième ligne, sans erreur de console. Résultat mesuré :
     `.pdp__coloris` = 0 occurrence sur toutes les fiches, et 9 règles CSS
     orphelines. Le handle se lit dans le CHEMIN, qui peut être préfixé par une
     collection : /collections/<x>/products/<handle>. */
  const handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
  if (!handle) return;

  // à quelle famille appartient la pièce affichée ?
  let famille = null, membres = null;
  for (const [nom, liste] of Object.entries(FAM)) {
    if (liste.some(x => x.handle === handle)) { famille = nom; membres = liste; break; }
  }
  if (!membres || membres.length < 2) return;

  // point d'insertion : juste avant le sélecteur de tailles, sinon avant l'ajout au panier
  const panneau = document.querySelector('.pdp__sticky') || document.querySelector('.pdp__panel');
  if (!panneau) return;
  const ancre = panneau.querySelector('.pdp__sizes') || panneau.querySelector('.pdp__atc');
  if (!ancre) return;

  const find = h => P.find(p => p.handle === h);
  const esc = s => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  const dispo = membres.filter(m => find(m.handle));
  if (dispo.length < 2) return;

  /* Le nom de la pastille vient du TITRE VIVANT du produit, plus d'une
     étiquette recopiée à la main dans familles-data.js.
     Mesuré le 20/10/2026 : 17 étiquettes sur 47 menaient à un autre produit
     que celui annoncé — « Noir » ouvrait le Hoodie Basique Melon Orange, et
     « Melon Orange » ouvrait le noir. Les pièces avaient été renommées dans
     l'admin et le fichier était resté sur les anciens noms.
     On retire le préfixe commun à la ligne pour ne garder que ce qui
     distingue : « Hoodie Basique Melon Orange » → « Melon Orange ».
     Conséquence voulue : renommer un produit dans l'admin corrige sa pastille
     tout seul, sans toucher à un fichier. */
  const motsDe = t => String(t || '').trim().split(/\s+/).filter(Boolean);
  const titres = dispo.map(m => find(m.handle).title || '');
  let commun = motsDe(titres[0]);
  titres.forEach(t => {
    const w = motsDe(t);
    let i = 0;
    while (i < commun.length && i < w.length
           && commun[i].toLowerCase() === w[i].toLowerCase()) i++;
    commun = commun.slice(0, i);
  });
  const pieces = dispo.map((m, i) => {
    const reste = motsDe(titres[i]).slice(commun.length).join(' ');
    return Object.assign({}, m, { nom: reste || m.nom || titres[i] });
  });

  const courant = pieces.find(m => m.handle === handle);
  const bloc = document.createElement('div');
  bloc.className = 'pdp__coloris';
  bloc.innerHTML = `
    <div class="pdp__colhead">
      <span class="label">Coloris</span>
      <span class="pdp__colnom" data-col-nom>${esc(courant ? courant.nom : '')}</span>
    </div>
    <div class="pdp__colrow">
      ${pieces.map(m => {
        const p = find(m.handle);
        const actif = m.handle === handle;
        const epuise = p && p.available === false;
        return `<a class="pdp__col${actif ? ' is-on' : ''}${epuise ? ' is-out' : ''}"
           href="${m.url || "/products/" + m.handle}"
           style="--pastille:${esc(m.hex)}"
           title="${esc(m.nom)}${epuise ? ' — épuisé' : ''}"
           aria-label="${esc(m.nom)}${epuise ? ' (épuisé)' : ''}"
           ${actif ? 'aria-current="true"' : ''} data-col="${esc(m.nom)}"></a>`;
      }).join('')}
    </div>
    <p class="pdp__colcount label">${pieces.length} coloris dans cette ligne</p>`;
  ancre.parentNode.insertBefore(bloc, ancre);

  // le nom suit la pastille survolée, puis revient au coloris affiché
  const sortie = bloc.querySelector('[data-col-nom]');
  const parDefaut = courant ? courant.nom : '';
  bloc.querySelectorAll('.pdp__col').forEach(a => {
    a.addEventListener('pointerenter', () => { sortie.textContent = a.dataset.col; });
    a.addEventListener('pointerleave', () => { sortie.textContent = parDefaut; });
  });
})();
